import $ from 'jquery';

export default function() {
	/*$('form.js_gtmevents_search').on('submit', function() {
		dataLayer.push({"event": "search", "vGtm1": "search", "vGtm2": window.location.pathname});
	});

	$('form.js_gtmevents_search #fulltext').on('click', function() {
		dataLayer.push({"event": "search", "vGtm1": "click", "vGtm2": window.location.pathname});
	});*/

	/*$('body')
		.on('AUTOCOMPLETE_TAG_SELECTED_BY_USER', function() {
			dataLayer.push({"event": "search", "vGtm1": "search", "vGtm2": window.location.pathname});
		})

		.on('click', '.js_tags-autocomplete-manually-add-tag', function(e) {
			e.preventDefault();
			dataLayer.push({"event": "search", "vGtm1": "popular", "vGtm2": window.location.pathname});
		});*/

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/gtm-event/search-events.js